module.exports = __webpack_public_path__ + "img/TIRED.f75c6375.png";